<ng-template [cxOutlet]="CartOutlets.LIST_ITEM">
  <td role="cell">
    <ng-template
      [cxOutlet]="CartOutlets.ITEM_CONFIGURATOR_ISSUES"
    ></ng-template>
    <cx-cart-item-validation-warning
      [code]="getProductCode()"
    ></cx-cart-item-validation-warning>
    <div class="cx-table-item-container">
      <!-- Item Image -->
      <a
        [routerLink]="{ cxRoute: 'product', params: item.product } | cxUrl"
        tabindex="0"
      >
        <cx-media
          [container]="getProductImage()"
          format="cartIcon"
        ></cx-media>
      </a>
      <div class="cx-info">
        <div *ngIf="item.product?.name" class="cx-name">
          <a
            class="cx-link"
            [routerLink]="{ cxRoute: 'product', params: item.product } | cxUrl"
          >{{ item.product?.name }}</a
          >
        </div>
        <div *ngIf="item.product?.code" class="cx-code">
          {{ 'cartItems.id' | cxTranslate }} {{ item.product?.code }}
        </div>
        <!-- Item Price -->
        <div *ngIf="item.basePrice" class="cx-price">
          <div *ngIf="item.basePrice" class="cx-value">
            {{ item.basePrice.formattedValue }}
          </div>
        </div>
      </div>
    </div>
    <div class="cx-cart-addons">
      <!-- Item Details Outlet -->
      <ng-template [cxOutlet]="CartOutlets.ITEM_DETAILS"> </ng-template>

      <!-- Item Bundle Details Outlet -->
      <ng-template [cxOutlet]="CartOutlets.ITEM_BUNDLE_DETAILS"> </ng-template>

      <!-- Promotion -->
      <cx-promotions [promotions]="getPromotions()"></cx-promotions>

      <!-- Item Delivery Details Outlet -->
      <ng-template
        *ngIf="!readonly"
        [cxOutlet]="CartOutlets.ITEM_DELIVERY_DETAILS"
        [cxOutletContext]="{ item, cartType: options.cartType }"
      ></ng-template>
    </div>

    <!-- Variants -->
    <ng-container *ngIf="item.product?.baseOptions?.length">
      <div
        *ngFor="
          let variant of getVariantQualifiers(item)
        "
        class="cx-property"
      >
        <!-- cx-mobile-header -->
        <div class="cx-label" *ngIf="variant.name && variant.value">
          {{ variant.name }}: {{ variant.value }}
        </div>
      </div>
    </ng-container>
  </td>
  <td role="cell" class="cx-length"  *ngIf="!isAsturias">
    {{item.customLength}} mm
  </td>
  <!-- Item Quantity -->
  <td role="cell" class="cx-quantity">
    <div
      class="cx-mobile-header"
      placement="left"
      title="{{ 'cartItems.quantityTitle' | cxTranslate }}"
    >
      {{ 'cartItems.quantity' | cxTranslate }}
    </div>
    <!-- Availability -->
    <span
      role="cell"
      *ngIf="isProductOutOfStock(item.product) && !readonly"
      class="cx-availability"
    >
      {{ 'addToCart.outOfStock' | cxTranslate }}
    </span>
    <div class="cx-value" [class.readonly-value]="readonly">
      <cx-item-counter
        [control]="quantityControl"
        [readonly]="getReadonly()"
        [max]="getMax()"
        [allowZero]="true"
      >
      </cx-item-counter>
    </div>
  </td>
  <td
    role="cell"
    class="cx-amount"
    (keypress)="updateEntryPackageValue($event)"
    *ngIf="!isAsturias && item.product?.code?.includes('_p') && !readonly"
  >
    <app-gonvarri-chapa-quantity
      [numberOfSheets]="getNumberOfSheets()"
      [product]="getProduct()"
      (updatePackageAndSheets)="updateNumberOfSheets($event)"
      [hideTexts]="true"
    />
  </td>
  <td
    role="cell"
    class="cx-amount"
    *ngIf="!isAsturias && ((item.product?.code?.includes('_p') && readonly) || !(item.product?.code?.includes('_p')))"
  >
    {{getNumberOfSheets()}}
  </td>
  <td role="cell" class="cx-amount" *ngIf="isAsturias">
    {{this.item.product?.tubesPerPackage}}
  </td>
  <td role="cell" class="cx-weight">
    {{item.packageWeight}} KG
  </td>
  <td role="cell" class="cx-totalWeight">
    {{calculateTotalWeight()}} KG
  </td>
  <td role="cell" class="cx-price">
    {{item.basePrice?.formattedValue}}<span *ngIf="!isAsturias"> / Tm</span><span *ngIf="isAsturias"> / 100m.l</span>
  </td>
  <!-- Display quote discount new price input if is ASM (isSeller) -->
  <td role="cell" class="cx-newPrice" *ngIf="cartId && isQuote && isSeller && item.entryNumber !== undefined">
    <app-gonvarri-product-quote-discount
      [entryNumber]="item.entryNumber"
      [quoteCode]="cartId"
      [disableDiscountInput]="getReadonly()"
      [quotePromotionNewPrice]="item.quotePromotionNewPrice?.value"
    />
  </td>
  <!-- Display fixed quote new price if is not ASM (!isSeller) -->
  <td role="cell" 
    *ngIf="cartId && isQuote && !isSeller && item.entryNumber !== undefined" 
    [class.cx-quote-entry-new-promotion-price]="item.quotePromotionNewPrice?.value ?? 0 > 0"
  >
    {{ (item.quotePromotionNewPrice?.value ?? 0) > 0 ? item.quotePromotionNewPrice?.formattedValue + " / Tm" : "N/A" }}
  </td>
  <td role="cell" class="cx-offer" *ngIf="!isAsturias && !isQuote">
    {{getDiscountValueForEntry(item)}}
  </td>
  <!-- Mobile Item Price -->
  <td role="cell" *ngIf="item.basePrice" class="cx-price cx-mobile-only">
    <div class="cx-mobile-header">
      {{ 'cartItems.itemPrice' | cxTranslate }}
    </div>
    <div *ngIf="item.basePrice" class="cx-value">
      {{ item.basePrice.formattedValue }}
    </div>
  </td>
  <!-- Total -->
  <ng-container *ngIf="options.isSaveForLater; else total">
    <td role="cell" class="cx-total">
      <div class="cx-mobile-header">
        {{ 'saveForLaterItems.stock' | cxTranslate }}
      </div>
      <div
        *ngIf="getStockLevel() >= 0; else forceInstock"
        class="cx-value"
      >
        {{ item.product?.stock?.stockLevel }}
      </div>
      <ng-template #forceInstock>
        <div class="cx-value">
          {{ 'saveForLaterItems.forceInStock' | cxTranslate }}
        </div>
      </ng-template>
    </td>
  </ng-container>

  <td
    role="cell"
    *ngIf="
      (!readonly || options.isSaveForLater || options.displayAddToCart) &&
      item.updateable
    "
    class="cx-actions"
  >
    <ng-container *ngIf="!isProductOutOfStock(item.product)">
      <ng-container
        *ngTemplateOutlet="
          options.optionalBtn;
          context: {
            $implicit: {
              loading: quantityControl.disabled,
              item: this.item,
              options: this.options
            }
          }
        "
      ></ng-container>
    </ng-container>
    <button
      *ngIf="!readonly"
      (click)="removeItem()"
      [cxAtMessage]="'cartItems.itemRemoved' | cxTranslate"
      [disabled]="quantityControl.disabled"
      attr.aria-label="{{ 'addToCart.removeFromCart' | cxTranslate }}"
      class="btn btn-tertiary cx-remove-btn"
    >
      {{ 'common.remove' | cxTranslate }}
    </button>
  </td>
  <td *ngIf="enableAddToCart && item.product && item.product.code">
    <cx-add-to-cart
      [productCode]="item.product.code"
      [product]="item.product"
      [showQuantity]="false"
      [options]="{
        displayAddToCart: enableAddToCart,
        addToCartString: 'addToCart.buyItAgain' | cxTranslate
      }"
      [pickupStore]="item.deliveryPointOfService?.name"
      class="add-to-cart"
    >
    </cx-add-to-cart>
  </td>
</ng-template>
<ng-template #total>
  <td role="cell" *ngIf="item.totalPrice" class="cx-total">
    <div class="cx-mobile-header">
      {{ 'cartItems.total' | cxTranslate }}
    </div>
    <div class="cx-value">{{ item.totalPrice.formattedValue }}</div>
  </td>
</ng-template>
